import { BagImage, BlobWrapper, ButtonWrapper } from '../Porktein/Porktein.styles'
import Image from 'next/image'
import bag from '../../../../../../../../public/assets/product/bisonBag.webp'
import shoelace from '../../../../../../../../public/assets/product/shoeLaceArrow.webp'
import cup from '../../../../../../../../public/assets/product/cupArrow.webp'
import snake from '../../../../../../../../public/assets/product/snakeArrow.webp'
import badge from '../../../../../../../../public/assets/badge-3-red.svg'
import { useTranslation } from 'hooks/useTranslation'
import { SectionTitle } from '../../Treats.styles'
import { Button } from 'components/Button'
import { BisonRoot, Feat1, Feat2, Feat3, Cup, Snake, Shoelace, BadgeWrapper } from './Bison.styles'
import { TreatsBlob } from '../Porktein/Porktein'

export const Bison = () => {
  const { t } = useTranslation()
  return (
    <BisonRoot>
      <SectionTitle className="d-only">{t('products:treats.bison.title')}</SectionTitle>
      <SectionTitle css={{ maxWidth: '300px' }} className="m-only">
        {t('products:treats.bison.title-mobile')}
      </SectionTitle>
      <BagImage>
        <Image src={bag} alt={t('products:treats.bison.imageAlt')} />
      </BagImage>
      <BlobWrapper className="d-only">
        <TreatsBlob color="tertiary-200" />
      </BlobWrapper>
      <BadgeWrapper>
        <Image src={badge} objectFit="cover" layout="fill" alt={t('recipes:overview.hero.badge')} />
      </BadgeWrapper>
      <Feat1
        align="center"
        weight="semiBold"
        size={{ '@initial': 'headline', '@bp3': 'bodyExtraLarge' }}
        color="accent-black"
      >
        {t('products:treats.bison.feat-1')}
      </Feat1>
      <Feat2
        align="center"
        weight="semiBold"
        size={{ '@initial': 'headline', '@bp3': 'bodyExtraLarge' }}
        color="accent-black"
      >
        {t('products:treats.bison.feat-2')}
      </Feat2>
      <Feat3
        align="center"
        weight="semiBold"
        size={{ '@initial': 'headline', '@bp3': 'bodyExtraLarge' }}
        color="accent-black"
      >
        {t('products:treats.bison.feat-3')}
      </Feat3>
      <Shoelace>
        <Image src={shoelace} alt="" />
      </Shoelace>
      <Snake className="d-only">
        <Image src={snake} alt="" />
      </Snake>
      <Cup>
        <Image src={cup} alt="" />
      </Cup>
      <ButtonWrapper>
        <Button>{t('products:treats.hero.cta')}</Button>
      </ButtonWrapper>
    </BisonRoot>
  )
}
